<script setup>
defineProps({
  variant: {
    type: String,
    default: "recent",
    validator: (v) => ["recent", "starred"].includes(v),
  },
});
</script>

<template>
  <div data-testid="empty-document-state" :data-variant="variant" class="flex flex-col items-center justify-center py-20 px-6 gap-5">
    <!-- Icon circle with badge -->
    <div class="relative flex items-center justify-center w-[88px] h-[88px] rounded-full bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-500 shrink-0">
      <!-- Document base -->
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8L14 2z"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14 2v6h6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8 13h8M8 17h5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      </svg>

      <!-- Clock badge (recent) -->
      <div v-if="variant === 'recent'"
        class="absolute bottom-2.5 right-2.5 flex items-center justify-center w-6 h-6 rounded-full bg-white dark:bg-slate-800 border-2 border-slate-100 dark:border-slate-700 text-slate-400 dark:text-slate-500">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2.5" />
          <path d="M12 7v5l3 3" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
        </svg>
      </div>

      <!-- Star badge (starred) -->
      <div v-else
        class="absolute bottom-2.5 right-2.5 flex items-center justify-center w-6 h-6 rounded-full bg-white dark:bg-slate-800 border-2 border-slate-100 dark:border-slate-700 text-slate-400 dark:text-slate-500">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      </div>
    </div>

    <!-- Text -->
    <div class="flex flex-col items-center gap-2 text-center max-w-xs">
      <p class="text-lg font-bold text-slate-800 dark:text-slate-100 m-0">
        {{ variant === "recent" ? "No recent documents" : "No starred documents" }}
      </p>
      <p class="text-sm text-slate-500 dark:text-slate-400 leading-relaxed m-0">
        {{ variant === "recent"
          ? "Documents you open will appear here for quick access."
          : "Star your important documents to find them here quickly." }}
      </p>
    </div>
  </div>
</template>
